module.exports = __webpack_public_path__ + "images/powered-by-home.1a0ca64e.svg";